import { render, staticRenderFns } from "./MoreList.vue?vue&type=template&id=5054c4ef&scoped=true"
import script from "./MoreList.vue?vue&type=script&lang=js"
export * from "./MoreList.vue?vue&type=script&lang=js"
import style0 from "./MoreList.vue?vue&type=style&index=0&id=5054c4ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054c4ef",
  null
  
)

export default component.exports